<template>
    <div class="approval-template-pop">
      <el-tabs type="card" v-model="tabName">
           <!-- 审批流 -->
          <el-tab-pane name="first" label="审批流">
             <el-form size="mini" ref="approvalTemplateForm" style="height:530px;overflow-y: auto" :model="templateInfo" label-width="120px">
                <el-row>
                  <el-col :span="8">
                    <el-row>
                        <el-col :span="20">
                            <el-form-item label="模板名称"
                            prop="templateName"
                            :rules="[
                                { required: true, message: '请输入模板名称', trigger: 'blur' },
                            ]"
                            >
                                <el-input :readonly="isRead" v-model="templateInfo.templateName"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-tooltip content="审批流实例名称的命名规则配置" placement="top">
                                <el-button type="primary" size="mini" icon="el-icon-s-tools" title="审批实例命名规则" style="margin-left: 5px;" circle @click="handleApprovalTitleRuleDialog()"></el-button>
                            </el-tooltip>
                        </el-col>
                    </el-row>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="审批类型"
                        prop="busiType"
                        :rules="[
                          { required: true, message: '请选择审批类型', trigger: 'change' },
                        ]"
                      >
                        <BusinessTree
                            :isRead="isRead"
                            v-if="showTree"
                            ref="treeChild"
                            :popover="true"
                            :data="businessTree"
                            :defaultProps="{}"
                            :defaultClass="'business-tree-form'"
                            @nodeClick="handleTreeNode"
                        />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                      <DataOperateEdit ref="dataOperate" :dataOperate='templateInfo.dataOperate' :isApproval="true" :isRead="isRead"/>
                   </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="审批方式">
                            <el-radio-group v-model="templateInfo.approvalMethod" :disabled="isRead" @change="approvalMethodChangeHandler">
                                <el-tooltip class="item" effect="dark" content="按照选择的人员顺序审批" placement="top">
                                    <el-radio :label="1">普通审批</el-radio>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="每个审批流节点内多人或签/会签审批，默认或签" placement="top">
                                    <el-radio :label="2">同节点多人审批</el-radio>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="审批根据表单内的人员字段自动获取审批人员" placement="top">
                                    <el-radio :label="3" :disabled="isCanChoose()">表单人员审批</el-radio>
                                </el-tooltip>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="顺序模式">
                            <el-radio-group v-model="templateInfo.orderMode" :disabled="isRead" >
                                <el-tooltip class="item" effect="dark" content="可以跨级审批，无先后顺序。注：其他人未审批，但终极审批人通过，则整个审批通过。" placement="top">
                                    <el-radio :label="0" >自由模式</el-radio>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="按设定的审批节点顺序，逐级审批" placement="top">
                                    <el-radio :label="1" >固定模式</el-radio>
                                </el-tooltip>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                   <el-col v-if="templateInfo.approvalMethod == 1" :span="8">
                      <el-form-item label="审批人员"
                        prop="selectedUser.selectedUserIds"
                        :rules="[
                          { required: false, message: '请选择审批人员', trigger: 'change' },
                        ]"
                      >
                          <el-tooltip :disabled="!selectedUser.selectedUserNames" :content="selectedUser.selectedUserNames" effect="light" placement="top">
                            <el-input v-if="!isRead" readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                            <el-input v-else readonly v-model="selectedUser.selectedUserNames" ></el-input>
                          </el-tooltip>
                      </el-form-item>
                   </el-col>
                    <el-col v-if="templateInfo.approvalMethod > 1" :span="8">
                        <el-form-item label="驳回模式">
                            <el-radio-group v-model="templateInfo.rejectMode" :disabled="isRead" >
                                <el-tooltip class="item" effect="dark" content="审批进程内，只要有人驳回就将该审批流更新为驳回状态" placement="top">
                                    <el-radio :label="0" >一票否决</el-radio>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="审批进程内，审批会签节点驳回比例达到指定值才会将该审批流更新为驳回状态" placement="top">
                                    <el-radio :label="1" >按会签比例</el-radio>
                                </el-tooltip>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item v-if="templateInfo.approvalMethod == 2" label="审批流" class="executor">
                        <el-steps class="executors" :key="loadTimer" :active="templateInfo.approvalList.length" :align-center="templateInfo.approvalList.length > 0">
                            <el-step v-for="(item, index) in templateInfo.approvalList" :key="index" align-center @click.native="chooseApproveUser(index)"   >
                                <el-breadcrumb v-if="item && item.length > 0" slot="title" :separator="(templateInfo.approvalUserGroupList[index].approvalMultiSignType == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item" :key="i">{{user.trueName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                            <el-step :key="templateInfo.approvalList.length + 1" icon="el-icon-circle-plus-outline" @click.native="addApproval"></el-step>
                        </el-steps>
                        <el-steps class="executors-proportion" :key="renderTimer" :active="templateInfo.approvalList.length" :align-center="templateInfo.approvalList.length > 0">
                            <el-step v-for="(item, index) in templateInfo.approvalList" :key="index" align-center>
                                <el-breadcrumb v-if="item && item.length > 0" slot="title">
                                    <el-input-number v-model="templateInfo.approvalUserGroupList[index].proportion" :precision="0" :step="1" :min="1" :max="100" v-if="templateInfo.approvalUserGroupList[index].approvalMultiSignType == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                    <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                       <i class="el-icon-question" v-if="templateInfo.approvalUserGroupList[index].approvalMultiSignType == 2"></i>
                                    </el-tooltip>
                                </el-breadcrumb>
                            </el-step>
                            <el-step  icon="el-icon-circle-plus-outline" class="opera-btn"></el-step>
                        </el-steps>
                    </el-form-item>
                    <el-form-item v-if="templateInfo.approvalMethod == 3" label="审批流" class="executor">
                        <el-steps class="executors" :active="approvePeopleList.length" :align-center="approvePeopleList.length > 0">
                            <el-step v-for="(item, index) in approvePeopleList" :key="index" align-center>
                                <el-breadcrumb slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                    <el-breadcrumb-item  v-for="(user, i) in item.approvePeoples" :key="i">{{user.approvePeopleType=='user'?user.selectedUserName:user.fieldName}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                        <el-steps class="executors-proportion" :key="renderTimer" :active="approvePeopleList.length" :align-center="approvePeopleList.length > 0">
                            <el-step v-for="(item, index) in approvePeopleList" :key="index" align-center>
                                <el-breadcrumb  slot="title" :separator="(item.approveWay == 2?'+':'/')">
                                    <el-input-number v-model="item.proportion" :precision="0" :step="1" :min="1" :max="100" v-if="item.approveWay == 2" placeholder="会签比例" @change="changeProportionVal(item)"></el-input-number>
                                    <el-tooltip class="item" effect="dark" content="设置会签比例后当会签节点审批通过的人数达到了会签比例数则此审批节点直接通过,不配置则代表会签节点审批人员全部通过后节点状态才算通过,设置数字的单位为百分比,比例最大值为100就是代表百分之一百" placement="top-end">
                                       <i class="el-icon-question" v-if="item.approveWay == 2"></i>
                                    </el-tooltip>
                                </el-breadcrumb>
                            </el-step>
                        </el-steps>
                        <i class="el-icon-circle-plus-outline" @click="addApprovePeopleList" style="font-size:20px;cursor:pointer;"></i>
                    </el-form-item>

                    <el-form-item v-if="templateInfo.approvalMethod == 1" label="审批流">
                      <el-steps v-if="totalNum>0" :active="totalNum" align-center>
                        <el-step v-for="(item, index) in selectUsers" :key="index" :title="item"></el-step>
                      </el-steps>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="5" >
                        <el-form-item label="审批时间设置">
                            <el-tooltip class="item" effect="dark" content="设置多少小时内完成审批,到期提醒未处理审批的审批人" placement="top">
                                <el-input-number v-model="templateInfo.durTime" :min="0" :max="9999" :disabled="isRead"></el-input-number>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" >
                        <el-form-item label="短信通知">
                            <el-checkbox v-model="templateInfo.sendSms" :disabled="isRead">短信通知审批人</el-checkbox>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" >
                        <el-form-item label="驳回删除旧数据">
                            <el-tooltip class="item" effect="dark" content="审批驳回后是否删除旧数据" placement="top">
                                <el-checkbox v-model="templateInfo.isDeleteOldData" :disabled="isRead"></el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="5" >
                        <el-form-item label="提醒设置" >
                            <el-tooltip class="item" effect="dark" content="到期提醒未处理审批的审批人" placement="top">
                                <el-date-picker
                                    v-model="templateInfo.warnDate"
                                    type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :editable="true"
                                    placeholder="选择日期时间"
                                    :disabled="isRead">
                                </el-date-picker>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12" >
                     <el-form-item label="抄送人员" >
                        <!-- <el-tooltip :disabled="!selectedCopyUser.selectedUserNames" :content="selectedCopyUser.selectedUserNames" effect="light" placement="top">
                            <el-input readonly v-model="selectedCopyUser.selectedUserNames" @focus="chooseCopyUser" ></el-input>
                        </el-tooltip> -->
                          <el-tag v-for="(item,index) in copyUserObj" :key="index" style="margin-left:4px;" closable @close="handleClose(item)">{{item.trueName}}</el-tag>
                          <el-dropdown @command="handleCommand">
                            <el-button>
                            添加抄送人员<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu  split-button slot="dropdown">
                            <el-dropdown-item command="1">人员列表</el-dropdown-item>
                            <el-dropdown-item command="2">表单字段</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        
                    </el-form-item>
                  </el-col>
                   <el-col v-if="templateInfo.approvalMethod != 2" :span="12" >
                      <el-form-item label="或签人员" class="executor">
                         <el-tooltip class="item" effect="dark" content="可设置多个或签人员，设置后一旦任意一个或签人员进行审批，则整个审批流程完成" placement="top">
                          <div  v-if="countersignUsers==null || countersignUsers.length==0" style="cursor:pointer;">
                              <el-button size="mini" icon="el-icon-circle-plus-outline" title="添加或签人员" circle @click.stop="handleAddCountersignUsers()"></el-button>
                          </div>
                          <div v-else  class="executors">
                              <span v-for="(user, index) in countersignUsers" :key="user.userId" class="executor-item">
                                  {{user.trueName}}
                                  <i class="executor-del el-icon-circle-close" @click.stop="handleDeleteUser(index)" title="取消或签人"></i>
                              </span>
                          </div>
                          </el-tooltip>
                      </el-form-item>
                   </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8" >
                    <el-form-item label="历史审批人">
                        <el-tooltip class="item" effect="dark" content="每次发起审批时，重新选择审批人" placement="top">
                            <el-checkbox v-model="templateInfo.clearApprovalUsers" :disabled="isRead">清空历史审批人</el-checkbox>
                        </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="templateInfo.orderMode == 1">
                    <el-form-item label="待审批提前查阅">
                        <el-tooltip class="item" effect="dark" content="固定模式下审批信息是否可提前查阅" placement="top">
                            <el-checkbox v-model="templateInfo.showAllMyApprovals" :disabled="isRead">可提前查阅</el-checkbox>
                        </el-tooltip>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8" v-if="templateInfo.approvalMethod == 1 || templateInfo.approvalMethod == 3" >
                        <el-form-item label="部门指定审批人">
                            <el-tooltip class="item" effect="dark" content="普通模式和表单人员审批下,根据表单的部门字段来动态选择配置好的审批人" placement="top">
                                <el-checkbox v-model="templateInfo.deptApprovalUserMode" :disabled="isRead">部门指定审批人</el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 部门字段和审批人关系配置begin -->
                <el-form-item  v-if="templateInfo.deptApprovalUserMode==1" label="映射关系配置">
                    <div :key="deptUserlinkDataTime" class="approval-form-data-link-config">
                        <el-row>
                            <el-col :span="12" >
                                <div class="process-data-link-config-opera">
                                    <el-button type="primary" @click="addDeptUserlinkData">新增映射关系</el-button>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row  v-for="(obj,index) in templateInfo.deptUserlinkData" :key="index">
                            <el-col :span="4" >
                                <el-form-item label="部门字段">
                                    <el-select v-model="obj.formFieldId" placeholder="请选择部门字段" class="triggerSource" @change="handleDeptFieldChange(obj)">
                                        <el-option
                                            v-for="item in deptFieldList"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="4" >
                                <el-form-item label="部门值">
                                    <Department
                                        ref="deptTreeChild"
                                        :multiple="true"
                                        :selectedNode="obj.departmentTreeBO"
                                        :currentPK="obj.id"
                                        :popover="true"
                                        :ifFiltDataSource="true"
                                        @nodeClick="handleDeptTreeNode"
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" >
                                <el-form-item label="审批人">
                                    <el-input readonly v-model="obj.selectedUserNames" @focus="chooseDeptUser(obj.id)" ></el-input>
                                    <UserOrgPop :multiple="true" :key="loadTimer" :isShowUserOrg='isShowDeptFieldUserOrg' :selectedUser="obj"  :ref="'deptFieldUserOrg'+obj.id" @nodeClick="confirmDeptFieldUserOrg" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6" v-if="templateInfo.approvalMethod == 3">
                                <el-form-item label="范围">
                                    <el-tooltip class="item" effect="dark" content="表单人员审批下,仅重置节点类型是用户的审批节点，从表单内取人的节点不受影响" placement="top">
                                        <el-checkbox v-model="obj.onlyUserNode">仅用于用户类型节点</el-checkbox>
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                            <el-col :span="2" >
                                <div class="opear-delete"><i class="el-icon-delete" @click="delDeptUserlinkData(obj)"></i></div>
                            </el-col>
                        </el-row>
                    </div>
                </el-form-item>
                <!-- 部门字段和审批人关系配置end -->
                <el-row>
                    <el-col :span="8" >
                        <el-form-item label="审批名称配置">
                            <el-tooltip class="item" effect="dark" content="审批名称只读" placement="top">
                                <el-checkbox v-model="templateInfo.nameReadOnly" :disabled="isRead">只读</el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" >
                        <el-form-item label="审批人只读">
                            <el-tooltip class="item" effect="dark" content="审批人只读，只针对于普通审批和通节点多人审批这两种审批方式" placement="top">
                                <el-checkbox v-model="templateInfo.approvalUserReadOnly" :disabled="isRead">只读</el-checkbox>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" >
                        <el-form-item label="">
                            <el-tooltip class="item" effect="dark" content="摘要" placement="top">
                                <el-checkbox v-model="templateInfo.approvalAbstract" :disabled="isRead" @change="initAbstractFormData">摘要</el-checkbox>
                            </el-tooltip>
                            <el-select v-model="abstractFieldAValue" placeholder="请选择" multiple v-if="templateInfo.approvalAbstract" @change="buildAbstractField">
                                <el-option-group
                                v-for="group in abstractFieldArray"
                                :key="group.label"
                                :label="group.label">
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="模板说明">
                    <el-input :readonly="isRead" type="textarea" :rows="4" placeholder="请输入内容" v-model="templateInfo.remarks" />
                </el-form-item>
              </el-form>
          </el-tab-pane>
           <!-- 审批表单 -->
          <el-tab-pane name="second" label="审批表单">
            <el-row v-if="isShowForm">
              <div class="form-content">
                <el-collapse style="height:410px;overflow-y:auto;" v-model="collapseActiveName" accordion>
                    <el-collapse-item v-for="(form, index) in forms" :key="form.id" :title="form.formName" :name="form.id">
                        <template slot="title">
                            <div class='el-collapse-title'>
                                <span>【{{form.formName}}】</span>
                            </div>
                        </template>
                        <el-form :model="formData[index].values" :ref="'customForm'+index" label-width="165px" :id="`print${form.id}`">
                            <FieldItem v-for="(field,index2) in form.fieldsList" :findex="index2" :formId="form.id"  :formConfig="form" :key="field.fieldId" :field="field" :formData="formData[index].values" :isBelongApproval="true" :colSpan="form.colSpan" :fieldsList="form.fieldsList"/>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
              </div>
            </el-row>
          </el-tab-pane>
      </el-tabs>

         <el-dialog
            title="选择审批人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowUserOrg"
            append-to-body
          >
          <UserOrg  :key="loadTimer" ref="userOrg" :multiple="true" :selectedUser="selectedUser" :canDrop="true" />
          <span slot="footer" class="dialog-footer">
              <el-button v-if="templateInfo.approvalMethod == 2" type="primary" @click="confirmClick(1)">确定或签</el-button>
              <el-button v-if="templateInfo.approvalMethod == 2" type="primary" @click="confirmClick(2)">确定会签</el-button>
              <el-button v-if="templateInfo.approvalMethod != 2" type="primary" @click="confirmClick()">确定</el-button>
              <el-button @click="isShowUserOrg = false">取 消</el-button>
              <el-button v-if="templateInfo.approvalMethod == 2" type="danger" @click="handleDeleteNode">删除当前节点</el-button>
          </span>
        </el-dialog>

        <el-dialog
            title="选择抄送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCopyFieldUserOrg"
            v-if="isShowCopyFieldUserOrg"
            append-to-body
          >
          <UserOrg  :key="loadTimer" ref="copyFieldUserOrg" :multiple="true" :selectedUser="selectedCopyFieldUser" :canDrop="true" />
          <span slot="footer" class="dialog-footer">
              <el-button  type="primary" @click="confirmCopyFieldUserOrg()">确定</el-button>
              <el-button @click="isShowCopyFieldUserOrg = false">取 消</el-button>
          </span>
        </el-dialog>

        <el-dialog
            title="设置审批节点"
            top="4vh"
            width="75%"
            :visible.sync="isShowApproveSetNode"
            v-if="isShowApproveSetNode"
            custom-class="approveSetNode"
            append-to-body
          >
          <ApprovePeopleRule  :forms="forms"  @saveApproveRule="saveApproveRule" :approvePeopleArray="approvePeopleList"></ApprovePeopleRule>
        </el-dialog>

         <el-dialog
            title="审批名称命名规则"
            top="4vh"
            width="75%"
            :visible.sync="isShowNameRule"
            append-to-body
          >
          <ApprovalTitleRule :key="nameLoadTimer"  :forms="forms" :templateInfo="templateInfo" @confirmClick="saveNameRule" @cancelClick="closeNameRuleDialog"></ApprovalTitleRule>
        </el-dialog>

        <el-dialog
            title="选择抄送人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowCopyUserOrg"
            append-to-body
          >
            <UserOrg ref="userOrgExtCopy" :multiple="true" :selectedUser="selectedCopyUser" :canDrop="true"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowCopyUserOrg = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopyUserClick">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="选择表单字段人员"
            top="4vh"
            width="75%"
            :visible.sync="isShowFormFieldList"
            v-if="isShowFormFieldList"
            append-to-body
          >
          <el-select v-model="selectedField" multiple placeholder="请选择字段">
              <el-option-group
                v-for="group in fieldOptions"
                :key="group.label"
                :label="group.label">
                <el-option
                  v-for="item in group.options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-option-group>
            </el-select>
          <span slot="footer" class="dialog-footer">
              <el-button  type="primary" @click="setFormField()">确定</el-button>
              <el-button @click="isShowFormFieldList = false">取 消</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getBusinessTreeList, getFormConfigs } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import UserOrg from '@/components/UserOrg';
    import { isEmpty, cloneDeep } from 'lodash';
    import DataOperateEdit from '../ProcessEditor/components/DataOperateEdit';
    import ApprovePeopleRule from './ApprovePeopleRule';
    import { CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN,
        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
    } from '@/common/constants';

    export default {
        components: {
            DataOperateEdit,
            UserOrg,
            ApprovePeopleRule
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                currentDeptUserId: '',
                isShowDeptFieldUserOrg: false,
                deptFieldList: [],
                // deptUserlinkData: [], // 部门用户关系配置end
                nameLoadTimer: '',
                loadTimer: '',
                renderTimer: '',
                isShowCopyUserOrg: false,
                selectCopyUsers: [],
                selectedCopyUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectedCopyFieldUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                totalNum: 0,
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                selectUsers: [],
                showTree: false,
                tabName: 'first',
                businessTree: [],
                formObj: '',
                formData: [],
                forms: [],
                collapseActiveName: '',
                isShowForm: false,
                permission: {
                    startProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN
                    ],
                    designProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN
                    ],
                    publishProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN
                    ],
                    previewProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN
                    ],
                    configProcessTemplateBtn: [
                        CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN
                    ]
                },
                countersignUsers: [],
                isShowApproveSetNode: false,
                approvePeopleList: [],
                isShowNameRule: false,
                isShowFormFieldList: false,
                fieldOptions: [],
                userFieldList: [],
                selectedField: [],
                copyUserObj: [],
                isShowCopyFieldUserOrg: false,
                abstractFieldArray: [],
                abstractFieldAValue: [],
                abstractField: [],
                deptUserlinkDataTime: new Date().getTime()

            };
        },
        computed: {
            // forms () {
            //     if (isEmpty(this.formObj)) {
            //         return [];
            //     } else {
            //         return this.formObj.structure;
            //     }
            // }
        },
        watch: {
            'templateInfo.dataOperate.forms' (newVal, oldVal) {
                this._initFormData();
            }
        },
        created () {
            // this._initPage();
        },
        props: {
            templateInfo: {
                type: Object,
                default: function () {
                    return {
                        id: '',
                        templateName: '',
                        busiType: '',
                        busiTypeName: '',
                        remarks: '',
                        selectedUser: {
                            selectedUserIds: '',
                            selectedUserNames: ''
                        },
                        templateState: null,
                        forms: [],
                        users: [],
                        approvalList: [],
                        approvalPeopleList: [],
                        approvalUserGroupList: [],
                        dataOperate: {
                            dataSource: 3,
                            forms: []
                        },
                        collapseActiveName: '',
                        orderMode: 0,
                        rejectMode: 0,
                        sendSms: 0,
                        clearApprovalUsers: 0,
                        durTime: 0,
                        warnDate: '',
                        selectedCopyUser: {
                            selectedUserIds: '',
                            selectedUserNames: ''
                        },
                        countersignUsers: [],
                        currentIndex: 0, // 当前点击节点
                        approvalMethod: 1, // 审批方法，1:普通审批，2:节点或签审批
                        showAllMyApprovals: 1,
                        deptApprovalUserMode: 0,
                        nameReadOnly: 0, // 审批名称只读
                        approvePeopleList: [],
                        titleRuleBOs: [],
                        deptUserlinkData: [] // 部门用户关系配置
                    };
                }
            },
            isRead: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            async _initPage () {
                if (this.templateInfo.approvePeopleList) {
                    this.approvePeopleList = this.templateInfo.approvePeopleList;
                }
                await this._initFormData();
                let loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let treeList = await getBusinessTreeList();
                this.businessTree = treeList;
                this.showTree = true;
                this.loadTimer = new Date().getTime();
                this.resetShowStatus();
                if (this.templateInfo.copyUserObj && this.templateInfo.copyUserObj.length > 5) {
                    this.copyUserObj = JSON.parse(this.templateInfo.copyUserObj);
                    this.initFormFieldList();
                    this.setApprovePeople();
                    // console.log(this.copyUserObj);
                } else { // 以往的老数据
                    // console.log(this.templateInfo);
                    if (this.templateInfo.copyUserIds && this.templateInfo.copyUserIds != '' && this.templateInfo.copyUserIds.length > 5) { //
                        let selectedUserIds = this.templateInfo.copyUserIds;
                        let selectedUserNames = this.templateInfo.copyUserNames;
                        let selectedUserNamesArray = selectedUserNames.split(',');
                        let selectedUserIdsArray = selectedUserIds.split(',');
                        for (let i = 0; i < selectedUserIdsArray.length; i++) {
                            let userId = selectedUserIdsArray[i];
                            let trueName = selectedUserNamesArray[i];
                            let item = {userId: userId, trueName: trueName};
                            item.id = this.generateUUID();
                            item.approvePeopleType = 'user';
                            this.copyUserObj.push(item);
                        }
                    }
                }
                // 筛选出部门字段
                this.initFormDeptFieldList();
                loading.close();
                // console.log("===="+this.permission.designProcessTemplateBtn);
            },
            async initStruct () {
                let formIds = [];
                this.templateInfo.dataOperate.forms.forEach(element => {
                    formIds.push(element.formId);
                });
                let formsMap = await getFormConfigs(formIds.join(','));
                this.formObj = {};
                this.formObj.structure = [];
                for (var key in formsMap) {
                    if (formsMap[key]) {
                        this.formObj.structure.push(formsMap[key]);
                    }
                }
                this.forms = this.formObj.structure;
                // console.log(this.forms);
            },
            async _initFormData () {
                this.formData.length = 0;
                this.isShowForm = false;
                await this.initStruct();
                // this.forms = this.formObj.structure;
                // console.log(this.forms);
                if (this.forms && this.forms.length > 0) {
                    this.collapseActiveName = this.forms[0].id;// 默认打开第一个表单
                }
                this.forms.forEach(element => {
                    this.renderdefaultForm(element);
                });
                if (this.templateInfo.approvalAbstract) {
                    let jsonArray = JSON.parse(this.templateInfo.abstractField);
                    let arr = [];
                    jsonArray.forEach(element => {
                        arr.push(element.id);
                    });
                    this.abstractFieldAValue = arr;
                }
                this.isShowForm = true;
                this.initAbstractFormData();
            },
            renderdefaultForm (element) {
                let fieldsList = element.fieldsList;
                let values = {};
                let attributes = {};
                for (let index = 0, len = fieldsList.length; index < len; index++) {
                    const element = fieldsList[index];
                    values[element.id] = '';
                    attributes[element.id] = element.type;
                }
                this.formData.push({
                    formId: element.id,
                    values: values,
                    attributes: attributes,
                    colSpan: element.colSpan ? element.colSpan : 1,
                    ext1: element.ext1 ? Number(element.ext1) : 0
                });
            },
            // beforeHandleCommand (obj, index) {
            //     return {
            //         'data': obj,
            //         'command': index
            //     };
            // },
            handleCommand (obj) {
                // 人员字段和表单字段统统初始化
                this.initFormFieldList();
                if (obj == '1') {
                    // this.selectedUser = {};
                    setTimeout(() => { // 初始化
                        this.$refs.copyFieldUserOrg._initPage();
                    }, 0);
                    this.isShowCopyFieldUserOrg = true;
                } else if (obj == '2') {
                    this.isShowFormFieldList = true;
                }
            },
            confirmCopyFieldUserOrg () {
                this.setApprovePeople();
            },
            initFormFieldList () {
                let options = [];
                this.userFieldList = [];
                this.selectedField = [];
                let selectedUserIds = [];
                let selectedUserNames = [];
                for (let i = 0; i < this.forms.length; i++) {
                    let cur = this.forms[i];
                    let formName = cur.modelName;
                    let fieldsList = cur.fieldsList;
                    let optionsItem = {};
                    let itemOptions = [];
                    for (let j = 0; j < fieldsList.length; j++) {
                        let itemCur = fieldsList[j];
                        if (itemCur.type === 'user') {
                            itemCur.formId = cur.id;
                            itemOptions.push(itemCur);
                            this.userFieldList.push(itemCur);
                        }
                    }
                    if (itemOptions.length > 0) {
                        optionsItem.options = itemOptions;
                        optionsItem.label = formName;
                        optionsItem.formId = cur.id;
                        options.push(optionsItem);
                    }
                }
                this.fieldOptions = options;
                this.copyUserObj.forEach(item => {
                    if (item.approvePeopleType === 'formField') { // 表单内字段
                        this.selectedField.push(item.id);
                    } else if (item.approvePeopleType === 'user') {
                        selectedUserIds.push(item.userId);
                        selectedUserNames.push(item.trueName);
                    }
                });
                this.selectedCopyFieldUser = {selectedUserIds: selectedUserIds.join(','), selectedUserNames: selectedUserNames.join(',')};
            },
            setFormField () {
                this.setApprovePeople();
            },
            setApprovePeople () {
                // 清空现有数据
                this.copyUserObj = [];
                // 1.构造人员选择数据
                let approveUsersArry = this.addCopyFieldUser();
                // 2.构造表单字段
                let selectedFieldObj = this.addCopyFormField();
                if (approveUsersArry.length > 0) {
                    this.copyUserObj.push(...approveUsersArry);
                }
                if (selectedFieldObj.length > 0) {
                    this.copyUserObj.push(...selectedFieldObj);
                }
                this.templateInfo.copyUserObj = JSON.stringify(this.copyUserObj);
            },
            addCopyFormField () {
                let selectedFieldObj = [];
                for (let i = 0; i < this.userFieldList.length; i++) {
                    let cur = this.userFieldList[i];
                    for (let j = 0; j < this.selectedField.length; j++) {
                        if (this.selectedField[j] === cur.id) {
                            let item = {};
                            item.id = cur.id;
                            item.modelId = cur.modelId;
                            item.trueName = cur.name;
                            item.formId = cur.formId;
                            item.approvePeopleType = 'formField';
                            selectedFieldObj.push(item);
                        }
                    }
                }
                this.isShowFormFieldList = false;
                return selectedFieldObj;
            },
            addCopyFieldUser () {
                let approveUsersArry = [];
                // 获取当前选择的人员数据
                if (this.$refs.copyFieldUserOrg) {
                    this.$refs.copyFieldUserOrg.setChoosedUser();
                    let selectedUserIds = this.selectedCopyFieldUser.selectedUserIds;
                    let selectedUserNames = this.selectedCopyFieldUser.selectedUserNames;
                    let selectedUserIdsArray = selectedUserIds.split(',');
                    let selectedUserNamesArray = selectedUserNames.split(',');
                    for (let i = 0; i < selectedUserIdsArray.length; i++) {
                        let userId = selectedUserIdsArray[i];
                        let trueName = selectedUserNamesArray[i];
                        let item = {userId: userId, trueName: trueName};
                        item.id = this.generateUUID();
                        item.approvePeopleType = 'user';
                        approveUsersArry.push(item);
                    }
                    this.isShowCopyFieldUserOrg = false;
                } else {
                    if (this.selectedCopyFieldUser.selectedUserIds !== '' && this.selectedCopyFieldUser.selectedUserIds.length > 5) {
                        let selectedUserIds = this.selectedCopyFieldUser.selectedUserIds;
                        let selectedUserNames = this.selectedCopyFieldUser.selectedUserNames;
                        let selectedUserIdsArray = selectedUserIds.split(',');
                        let selectedUserNamesArray = selectedUserNames.split(',');
                        for (let i = 0; i < selectedUserIdsArray.length; i++) {
                            let userId = selectedUserIdsArray[i];
                            let trueName = selectedUserNamesArray[i];
                            let item = {userId: userId, trueName: trueName};
                            item.id = this.generateUUID();
                            item.approvePeopleType = 'user';
                            approveUsersArry.push(item);
                        }
                    }
                }
                return approveUsersArry;
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            resetShowStatus () {
                // if (!isEmpty(this.templateInfo.busiTypeName)) {
                let node = {};
                node.value = this.templateInfo.busiType;
                node.title = this.templateInfo.busiTypeName;
                setTimeout(() => { // 默认回显值
                    this.$refs.treeChild._refreshSelectedNode(node);
                }, 0);
                // }
                this.selectedUser = this.templateInfo.selectedUser;
                this.countersignUsers = this.templateInfo.countersignUsers;
                this.selectUsers = [];
                this.totalNum = 0;
                if (!isEmpty(this.selectedUser.selectedUserNames)) {
                    this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                    this.totalNum = this.selectUsers.length;
                }
                // 回显抄送人
                this.selectedCopyUser = this.templateInfo.selectedCopyUser;
                this.tabName = 'first';
            },
            handleTreeNode (data, node, tree) {
                this.templateInfo.busiType = data.id;
            },
            confirmClick (approvalMultiSignType) {
                this.$refs.userOrg.setChoosedUser();
                // this.appPublishData.users = this.selectedUser.selectedUserIds;
                // console.log("-------"+this.selectedUser.selectedUserNames);
                this.selectUsers = [];
                this.selectUsers = this.selectedUser.selectedUserNames.split(',');
                if (this.selectUsers.length > 15) {
                    this.$message({
                        message: '选择的审批人总数不能超过15人',
                        type: 'warning',
                        duration: 3000
                    });
                    this.selectUsers = [];
                    this.selectedUser.selectedUserIds = '';
                    this.selectedUser.selectedUserNames = '';
                    return false;
                }
                this.totalNum = this.selectUsers.length;
                this.templateInfo.selectedUser = this.selectedUser;
                if (this.templateInfo.approvalMethod === 2) {
                    let selectedUserIds = this.selectedUser.selectedUserIds.split(',');
                    this.templateInfo.approvalList[this.currentIndex] = [];
                    if (this.selectedUser.selectedUserIds) {
                        for (let index = 0, len = selectedUserIds.length; index < len; index++) {
                            this.templateInfo.approvalList[this.currentIndex].push({
                                executionGroupOrder: this.currentIndex,
                                userId: selectedUserIds[index],
                                trueName: this.selectUsers[index]
                            });
                        }
                        this.templateInfo.approvalUserGroupList[this.currentIndex].approvalMultiSignType = approvalMultiSignType;
                        this.loadTimer = new Date().getTime();
                    }
                }
                this.isShowUserOrg = false;
            },
            handleAddCountersignUsers () {
                this.countersignUsers = [];
                if (undefined === this.selectedUser.selectedUserIds || isEmpty(this.selectedUser.selectedUserIds)) {
                    this.$message({
                        message: '尚未选择审批人，请先选择审批人',
                        type: 'warning',
                        duration: 3000
                    });
                    return;
                }
                let selectedUserIds = this.selectedUser.selectedUserIds.split(',');
                for (let index = 0, len = selectedUserIds.length; index < len; index++) {
                    let element = {userId: selectedUserIds[index], trueName: this.selectUsers[index]};
                    this.countersignUsers[index] = element;
                }
                this.templateInfo.countersignUsers = this.countersignUsers;
            },
            chooseUser () {
                this.$nextTick(_ => {
                    setTimeout(() => { // 初始化
                        this.$refs.userOrg._initPage();
                    }, 0);
                    this.isShowUserOrg = true;
                });
            },
            checkFormField () {
                let flg = false;
                this.$refs['approvalTemplateForm'].validate((valid) => {
                    if (valid) {
                        flg = true;
                    } else {
                        flg = false;
                    }
                });
                return flg;
            },
            chooseCopyUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgExtCopy._initPage();
                }, 0);
                this.isShowCopyUserOrg = true;
            },
            confirmCopyUserClick () {
                this.$refs.userOrgExtCopy.setChoosedUser();
                this.selectCopyUsers = [];
                // console.log(this.selectedCopyUser.selectedUserNames);
                this.selectCopyUsers = this.selectedCopyUser.selectedUserNames.split(',');
                if (this.selectCopyUsers.length > 15) {
                    this.$message({
                        message: '选择的抄送人员总数不能超过15人',
                        type: 'warning',
                        duration: 3000
                    });
                    this.selectCopyUsers = [];
                    this.selectedCopyUser.selectedUserIds = '';
                    this.selectedCopyUser.selectedUserNames = '';
                    return false;
                }
                // console.log(this.templateInfo);
                this.templateInfo.selectedCopyUser.selectedUserIds = this.selectedCopyUser.selectedUserIds;
                this.templateInfo.selectedCopyUser.selectedUserNames = this.selectedCopyUser.selectedUserNames;
                this.isShowCopyUserOrg = false;
            },
            handleDeleteUser (index) {
                this.countersignUsers.splice(index, 1);
            },
            addApproval () {
                if (this.templateInfo.approvalList.length < 15) {
                    this.templateInfo.approvalList.push([]);
                    this.templateInfo.approvalUserGroupList.push({
                        executionGroupOrder: (this.templateInfo.approvalList.length - 1),
                        approvalMultiSignType: 1
                    });
                    this.loadTimer = new Date().getTime();
                }
            },
            approvalMethodChangeHandler (value) {
                this.selectUsers = [];
                this.selectedUser = {
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
            },
            chooseApproveUser (index) {
                this.currentIndex = index;
                this.selectUsers = [];
                this.selectedUser.selectedUserIds = '';
                this.selectedUser.selectedUserNames = '';
                let currentNode = this.templateInfo.approvalList[index];
                for (let i = 0, len = currentNode.length; i < len; i++) {
                    if (i === 0) {
                        this.selectedUser.selectedUserIds = currentNode[i].userId;
                        this.selectedUser.selectedUserNames = currentNode[i].trueName;
                    } else {
                        this.selectedUser.selectedUserIds = this.selectedUser.selectedUserIds + ',' + currentNode[i].userId;
                        this.selectedUser.selectedUserNames = this.selectedUser.selectedUserNames + ',' + currentNode[i].trueName;
                    }
                }
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs.userOrg._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            handleDeleteNode () {
                this.templateInfo.approvalList.splice(this.currentIndex, 1);
                this.templateInfo.approvalUserGroupList.splice(this.currentIndex, 1);
                this.isShowUserOrg = false;
            },
            isCanChoose () {
                if (this.templateInfo.dataOperate.forms.length > 0) {
                    return false;
                } else {
                    return true;
                }
            },
            addApprovePeopleList () {
                this.nameLoadTimer = new Date().getTime();
                this.isShowApproveSetNode = true;
            },
            saveApproveRule (obj) {
                this.approvePeopleList = obj;
                this.templateInfo.approvePeopleList = obj;
                this.isShowApproveSetNode = false;
            },
            changeProportionVal (obj) {
                this.renderTimer = new Date().getTime();
            },
            handleApprovalTitleRuleDialog () {
                this.nameLoadTimer = new Date().getTime();
                this.isShowNameRule = true;
            },
            saveNameRule (obj) {
                // console.log(obj);
                this.templateInfo.titleRuleBOs = obj;
                this.isShowNameRule = false;
            },
            closeNameRuleDialog () {
                this.isShowNameRule = false;
            },
            handleClose (obj) {
                for (let i = 0; i < this.copyUserObj.length; i++) {
                    if (this.copyUserObj[i].id === obj.id) {
                        this.copyUserObj.splice(i, 1);
                    }
                }
                this.initFormFieldList();
                this.setApprovePeople();
            },
            // ========================部门字段和审批人员配置begin=======================
            handleDeptFieldChange (obj) {
                // console.log(obj);
                this.currentDeptUserId = obj.id;
                for (let j = 0; j < this.deptFieldList.length; j++) {
                    if (this.deptFieldList[j].id === obj.formFieldId) {
                        obj.formId = this.deptFieldList[j].formId;
                        break;
                    }
                }
            },
            initFormDeptFieldList () {
                this.deptFieldList = [];
                for (let i = 0; i < this.forms.length; i++) {
                    let cur = this.forms[i];
                    let fieldsList = cur.fieldsList;
                    for (let j = 0; j < fieldsList.length; j++) {
                        let itemCur = fieldsList[j];
                        if (itemCur.type === 'department') {
                            itemCur.formId = cur.id;
                            this.deptFieldList.push(itemCur);
                        }
                    }
                }
            },
            chooseDeptUser (id) {
                this.currentDeptUserId = id;
                this.loadTimer = new Date().getTime();
                setTimeout(() => { // 初始化
                    this.$refs['deptFieldUserOrg' + this.currentDeptUserId][0]._initPage();
                }, 0);
                this.isShowDeptFieldUserOrg = true;
            },
            confirmDeptFieldUserOrg (selected) {
                let selectedDeptUser = selected.selectedUserNames.split(',');
                if (selectedDeptUser.length > 15) {
                    this.$message({
                        message: '选择的人员总数不能超过15人',
                        type: 'warning',
                        duration: 3000
                    });
                    return false;
                }
                for (let i = 0; i < this.templateInfo.deptUserlinkData.length; i++) {
                    let cur = this.templateInfo.deptUserlinkData[i];
                    if (cur.id === this.currentDeptUserId) {
                        cur.selectedUserIds = selected.selectedUserIds;
                        cur.selectedUserNames = selected.selectedUserNames;
                    }
                }
                this.isShowDeptFieldUserOrg = false;
            },
            handleDeptTreeNode (data, node, tree) {
                // console.log(data);
                // console.log(this.currentDeptUserId);
                // let repeatMap = new Map();
                // 部门
                for (let i = 0; i < this.templateInfo.deptUserlinkData.length; i++) {
                    let cur = this.templateInfo.deptUserlinkData[i];
                    // console.log(cur);
                    // if (!repeatMap.has(cur.formFieldValue + '')) {
                    //     repeatMap.set(cur.formFieldValue + '', cur);
                    // }
                    // if (repeatMap.has(data.id + '')) {
                    //     this.$message({
                    //         message: '不能设置重复的部门',
                    //         type: 'warning',
                    //         duration: 3000
                    //     });
                    // } else
                    if ((cur.id === this.currentDeptUserId) || (cur.id === data.currentPK)) {
                        cur.formFieldValue = data.id;
                    }
                }
            },
            addDeptUserlinkData () {
                let item = {
                    id: this.generateUUID(),
                    onlyUserNode: false,
                    formId: '',
                    formFieldId: '',
                    formFieldValue: '',
                    selectedUserIds: '',
                    selectedUserNames: ''
                };
                this.templateInfo.deptUserlinkData.push(item); // list尾部新增
                // this.deptUserlinkDataTime = new Date().getTime();
            },
            delDeptUserlinkData (e) {
                for (let i = 0; i < this.templateInfo.deptUserlinkData.length; i++) {
                    let cur = this.templateInfo.deptUserlinkData[i];
                    if ((cur.formFieldValue + '') === (e.formFieldValue + '')) { // 使用部门id来判断唯一性
                        this.templateInfo.deptUserlinkData.splice(i, 1);
                    }
                }
                this.deptUserlinkDataTime = new Date().getTime();
            },
            // ========================部门字段和审批人员配置end=======================
            initAbstractFormData () {
                this.abstractFieldArray = [];
                if (this.templateInfo.approvalAbstract) {
                    this.forms.forEach(element => {
                        let lable = element.formName;
                        let options = [];
                        let formId = element.id;
                        element.fieldsList.forEach(obj => {
                            let curName = obj.name;
                            let id = obj.id;
                            options.push({label: curName, value: id, formId: formId});
                        });
                        this.abstractFieldArray.push({label: lable, options: options});
                    });
                } else {
                    this.abstractFieldAValue = '';
                }
            },
            buildAbstractField () {
                this.abstractField = [];
                console.log(this.abstractFieldAValue);
                this.abstractFieldAValue.forEach(fieldId => {
                    this.forms.forEach(element => {
                        let obj = element.fieldsList.find(item => item.id === fieldId);
                        if (obj) {
                            let field = {id: obj.id, formId: obj.formId, modelId: obj.modelId, name: obj.name, type: obj.type};
                            this.abstractField.push(field);
                        }
                    });
                });
                this.templateInfo.abstractField = JSON.stringify(this.abstractField);
            }
        }
    };
</script>


<style lang="less">
  .approval-template-pop {
    .el-step__main .el-breadcrumb{
        display: inline-block;
        .el-breadcrumb__item{
            .el-breadcrumb__inner{
                color:#409eff;
                a:hover{
                    color:#409eff;
                }
            }
            .el-breadcrumb__separator{
                color:#409eff;
            }
        }

    }
    .el-step__icon.is-text{
      cursor: pointer;
    }
    .el-collapse-title {
        color: #4ebe17;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > .el-button {
            margin-right: 10px;
        }
    }
    .form-content{
      height:400px;
      .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
        margin-bottom:2px
      }
      .el-form-item__label{
        color: #333;
        font-weight: 700;
      }
    }
    .el-tabs__content{
      margin-top:5px
    }
    .executor {
        .executors {
            display: flex;
            flex-direction: row;
        }
        .executors-proportion{
            display: flex;
            flex-direction: row;
            .el-step{
               .el-step__head{
                   display: none;
               }
            }
            .opera-btn{
                display: none;
            }
        }
        .executor-del {
            cursor: pointer;
        }
        .select-executor {
            // display: flex;
            flex-direction: row;
        }
        .executor-item {
            margin: 0 6px;
            cursor: pointer;
            &>i {
                // display: none;
                visibility: hidden;
            }
        }
        .executor-item:hover {
            i {
                visibility: visible;
            }
        }
        .executor-input {
            width: 90px;
        }
    }
    .approval-form-data-link-config{
      .opear-delete { 
        cursor: pointer;
        /* text-align: right; */
        padding-right: 20px;
        height: 0px;
        z-index: 999;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/process/ProcessTemplate/ApprovalTemplatePop.vue